export class Model {

    constructor(private rawObject: any) {

    }

    getRawData() {
        return this.rawObject;
    }
}
